"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterDTO = exports.ExpiringStorage = exports.StorageAdapter = exports.ACTIONS = exports.SELECTORS = exports.STCK_STORE = exports.StockcarsStoreClass = void 0;
const store_1 = require("./store");
Object.defineProperty(exports, "StockcarsStoreClass", { enumerable: true, get: function () { return store_1.StockcarsStoreClass; } });
const selectors_1 = require("./selectors");
Object.defineProperty(exports, "SELECTORS", { enumerable: true, get: function () { return selectors_1.SELECTORS; } });
const actions_1 = require("./actions");
Object.defineProperty(exports, "ACTIONS", { enumerable: true, get: function () { return actions_1.ACTIONS; } });
const storage_adapter_1 = require("./persistence/storage-adapter");
exports.StorageAdapter = storage_adapter_1.default;
const expiring_storage_1 = require("./persistence/expiring-storage");
exports.ExpiringStorage = expiring_storage_1.default;
const filter_dto_1 = require("./utils/filter-dto");
exports.FilterDTO = filter_dto_1.default;
let STCK_STORE = null;
exports.STCK_STORE = STCK_STORE;
if (typeof window !== 'undefined') {
    window.stockcars = window.stockcars || {};
    if (!window.stockcars.STCK_STORE && typeof SETUPS !== 'undefined') {
        store_1.StockcarsStoreClass.getInstance(SETUPS.get('stockcar.scs.market.path'), SETUPS.get('stockcar.url.startpage'));
        exports.STCK_STORE = STCK_STORE = window.stockcars.STCK_STORE;
    }
}
//# sourceMappingURL=index.js.map